export default __webpack_public_path__ + "static/media/Weighbridge.f4eb57b3.svg";